import React from 'react';

const PendingHiresIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='evenodd'>
      <path d='M19 17c3.836 0 7 2.681 7 6.067 0 .515-.423.933-.944.933H12.944c-.521 0-.944-.418-.944-.933C12 19.68 15.164 17 19 17zm0-8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM9.5 9c.552 0 1 .448 1 1v1.5H12c.552 0 1 .448 1 1s-.448 1-1 1h-1.5V15c0 .552-.448 1-1 1s-1-.448-1-1v-1.5H7c-.552 0-1-.448-1-1s.448-1 1-1h1.5V10c0-.552.448-1 1-1z' />
    </g>
  </svg>
);

export default PendingHiresIcon;
